import { createSlice } from '@reduxjs/toolkit'

const courseLessonStatus = Object.freeze({
    LOADING: 'LOADING',
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
})

const initialState = {
    status: {
        markLessonAsCompleted: courseLessonStatus.LOADING,
    },
    errorMessage: {
        markLessonAsCompleted: null,
    },
    markLessonAsCompleted: {},
}

const courseLessonSlice = createSlice({
    name: 'courseLesson',
    initialState,
    reducers: {
        markLessonAsCompleted: state => {
            state.status.markLessonAsCompleted = courseLessonStatus.LOADING
        },
        markLessonAsCompletedSuccess: (state, action) => {
            state.markLessonAsCompleted = action.payload
            state.status.markLessonAsCompleted = courseLessonStatus.SUCCESS
        },
        markLessonAsCompletedError: (state, action) => {
            state.errorMessage.markLessonAsCompleted = action.payload
            state.status.markLessonAsCompleted = courseLessonStatus.FAILURE
        },
    },
})

const {
    markLessonAsCompleted,
    markLessonAsCompletedSuccess,
    markLessonAsCompletedError,
} = courseLessonSlice.actions

export const courseLessonActions = {
    markLessonAsCompleted,
    markLessonAsCompletedSuccess,
    markLessonAsCompletedError,
}

export const courseLessonSelectors = {
    errorMessage: state => {
        return {
            markLessonAsCompleted:
                state.courseLesson.errorMessage.markLessonAsCompleted,
        }
    },
    isFetching: state => {
        return {
            markLessonAsCompleted:
                state.courseLesson.status.markLessonAsCompleted ===
                courseLessonStatus.LOADING,
        }
    },
    hasError: state => {
        return {
            markLessonAsCompleted:
                state.courseLesson.status.markLessonAsCompleted ===
                courseLessonStatus.FAILURE,
        }
    },
    isSuccess: state => {
        return {
            markLessonAsCompleted:
                state.courseLesson.status.markLessonAsCompleted ===
                courseLessonStatus.SUCCESS,
        }
    },
    markLessonAsCompleted: state => state.courseLesson.markLessonAsCompleted,
}

const courseLessonReducer = courseLessonSlice.reducer

export default courseLessonReducer
